import { Struct, u8, Vector, str, Tuple } from 'scale-ts';
import { lookup } from './lookup.mjs';
import { v15Pallet } from './pallets.mjs';
import '../../utils/ss58-util.mjs';
import '../scale/Binary.mjs';
import '../scale/bitSequence.mjs';
import '../scale/char.mjs';
import { compactNumber } from '../scale/compact.mjs';
import { Hex } from '../scale/Hex.mjs';
import '../scale/fixed-str.mjs';
import '../scale/Variant.mjs';
import '../scale/ethAccount.mjs';
import { runtimeApi } from './runtime-api.mjs';

const extrinsic = Struct({
  version: u8,
  address: compactNumber,
  call: compactNumber,
  signature: compactNumber,
  extra: compactNumber,
  signedExtensions: Vector(
    Struct({
      identifier: str,
      type: compactNumber,
      additionalSigned: compactNumber
    })
  )
});
const v15 = Struct({
  lookup,
  pallets: Vector(Struct(v15Pallet)),
  extrinsic,
  type: compactNumber,
  apis: Vector(runtimeApi),
  outerEnums: Struct({
    call: compactNumber,
    event: compactNumber,
    error: compactNumber
  }),
  custom: Vector(Tuple(str, Struct({ type: compactNumber, value: Hex() })))
});

export { v15 };
//# sourceMappingURL=v15.mjs.map
